/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum TokenRefreshRequestGrantTypeEnum {
  RefreshToken = 'refresh_token',
}

export function instanceOfTokenRefreshRequestGrantTypeEnum(
  value: any
): boolean {
  for (const key in TokenRefreshRequestGrantTypeEnum) {
    if (
      Object.prototype.hasOwnProperty.call(
        TokenRefreshRequestGrantTypeEnum,
        key
      )
    ) {
      if (
        TokenRefreshRequestGrantTypeEnum[
          key as keyof typeof TokenRefreshRequestGrantTypeEnum
        ] === value
      ) {
        return true
      }
    }
  }
  return false
}

export function TokenRefreshRequestGrantTypeEnumFromJSON(
  json: any
): TokenRefreshRequestGrantTypeEnum {
  return TokenRefreshRequestGrantTypeEnumFromJSONTyped(json, false)
}

export function TokenRefreshRequestGrantTypeEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): TokenRefreshRequestGrantTypeEnum {
  return json as TokenRefreshRequestGrantTypeEnum
}

export function TokenRefreshRequestGrantTypeEnumToJSON(
  value?: TokenRefreshRequestGrantTypeEnum | null
): any {
  return value as any
}
